interface Option {
  key: string | number;
  value: string | number | boolean | null;
  text: string;
  description?: string;
}

interface DropDown {
  options: Option[];
  label: {
    children: string;
  };
  placeholder: string;
}

const dropdownOptions = (label: string, placeholder: string): DropDown => {
  return {
    options: [defaultOptions],
    label: {
      children: label,
    },
    placeholder,
  };
};

const defaultOptions = {
  key: 'select',
  value: null,
  text: 'Select',
};

export { dropdownOptions, DropDown, Option, defaultOptions };
